import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { AppRouteID } from '~/app-routes';
import { ContextMenuItem } from '~/components/context-menu-list/context-menu-list';
import { CommonURLParam } from '~/constants';
import {
	generateLink,
	generateLinkNoCustomisationParam,
} from '~/utils/router-utils';

export class ApiCorrelationId {
	public static readonly CORRELATION_ID = 'correlationId';

	public static buildLink(router: Router, correlationId: string): string {
		if (correlationId) {
			const link = generateLink(router, AppRouteID.ApiAudit, {
				[CommonURLParam.API_CORRELATION_ID]: correlationId,
			});
			return `<a href="/${link}" target="_blank">${correlationId}</a>`;
		} else {
			return '';
		}
	}

	/**
	 * Provided a unified method to build the link to api-audit form
	 * with the correlation id request parameter
	 *
	 *
	 * @param i18n i18n service
	 * @param correlationId correlation id
	 */
	public static buildApiAuditContextLink(
		i18n: I18N,
		correlationId: string,
	): ContextMenuItem {
		return {
			id: 'getApiCorrelationId',
			label: i18n.tr('route-title.api-audit'),
			iconClass: 'fas fa-external-link-alt',
			href: generateLinkNoCustomisationParam(AppRouteID.ApiAudit, {
				[CommonURLParam.API_CORRELATION_ID]: correlationId,
			}),
		};
	}

	/**
	 * Registered the link to the provided context menus
	 * when the correlation is available
	 *
	 * @param contextMenu context menu
	 * @param i18n i18n service
	 * @param correlationId correlation id
	 */
	public static registerApiAuditLinkIn(
		contextMenu: ContextMenuItem[],
		i18n: I18N,
		correlationId: string,
	): void {
		if (correlationId) {
			contextMenu.push(
				ApiCorrelationId.buildApiAuditContextLink(i18n, correlationId),
			);
		}
	}
}
